import { render } from "./longListComplaintItem.vue?vue&type=template&id=bac7f33e"
import script from "./longListComplaintItem.vue?vue&type=script&lang=js"
export * from "./longListComplaintItem.vue?vue&type=script&lang=js"

import exportComponent from "/srv/web-site/cn-shequ-web/source-code/cn-shequ-mobile/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__